import yup from "lib/yup-extended";

export const validations = yup.object({
  products: yup
    .array()
    .min(1, "Selecione pelo menos uma solução.")
    .required("Marque alguma opção"),
});
